{
  "ariaLabelCloseBtn": "Close",
  "ariaLabelBackButton": "Go back"
}
